(function ($, Promise) {

	// Setup the prototype inheritance
	extend(BaseGame, Chronocarte);

	// Constructor
	function Chronocarte() {

		// Super constructor
		BaseGame.call(this);

		// Variable to hold data
		this.data = false

		// Override toolbar screen since we have a screensaver
		this.activateToolbarFrom = 2;

		this.draggable = false;
		this.currentMapItem = -1;
		this.viewerHasBeenOpened = false;

		// Load data then init
		this.loadData();
	}

	Chronocarte.prototype.loadData = function () {

		// Load JSON
		var json = $.ajax({
			url: "data/chronocarte.json",
			dataType: 'json',
			cache: false,
			complete: $.proxy(function (data) {
				this.data = JSON.parse(data.responseText);
			}, this)
		}).promise().then($.proxy(function () {
			this.initGame();
		}, this));
	};


	Chronocarte.prototype.initGame = function () {


		// Preload images
		var preloadImages = [];
		$(this.data.maps).each(function (i, map) {
			if (typeof map.img == "object") {
				preloadImages.push(map.img.fr)
				preloadImages.push(map.img.en)
			} else {
				preloadImages.push(map.img);
			}
			$(map.hotspots).each(function (i, hotspot) {
				$(hotspot.images).each(function (i, hotspot_image) {
					preloadImages.push(hotspot_image.src)
				});
			});
		});
		$.preloadImages.apply(null, preloadImages);

		// Init chronocarte beahviour and DOM
		this.initDOM(this.data);

		// Go to first screen
		this.goToScreen(1);
		// this.goToScreen(4);
		// this.showHotspotViewer(0);
	};

	Chronocarte.prototype.goToScreen = function (screenId, callback) {

		// Super constructor
		BaseGame.prototype.goToScreen.call(this, screenId, callback);

		// On specifif screens, make specific actions
		if (screenId == 4) {

			// Load first map item
			this.displayMapItem(0);
			$("#timeline-cursor").css("left", this.findPointPosition(this.data.maps[0]) + "px")
		}

	}

	Chronocarte.prototype.initDOM = function () {

		// Create maps
		$(this.data.maps).each(function (i, n) {

			// Element
			var li = $("<li></li>");
			li.attr("id", n.name)
			li.html("<div class='map-infos'></div>");
			if (n.date_fr != "") {
				li.find(".map-infos").append("<div class='map-date i18n fading-i18n'><span class='fr'>" + n.date_fr + "</span><span class='en'>" + n.date_en + "</span></div>");
			}
			li.find(".map-infos").append("<div class='map-title i18n fading-i18n'><span class='fr'>" + n.title_fr + "</span><span class='en'>" + n.title_en + "</span></div>");
			if (n.description_fr != "") {
				li.find(".map-infos").append("<div class='map-description i18n fading-i18n'><span class='fr'>" + n.description_fr + "</span><span class='en'>" + n.description_en + "</span></div>");
			}
			if (n.credits_fr != "") {
				li.find(".map-infos").append("<div class='map-credits i18n fading-i18n'><span class='fr'>" + n.credits_fr + "</span><span class='en'>" + n.credits_en + "</span></div>");
			}

			// Append image, and hanle bilingual
			if (typeof n.img === 'object') {
				li.append("<div class='map-image-wrapper'><div class='image i18n fading-i18n'><img class='fr' src='" + n.img.fr + "'/><img class='en' src='" + n.img.en + "'/></div></div>");
			} else {
				li.append("<div class='map-image-wrapper'><div class='image'><img src='" + n.img + "'/></div></div>");
			}

			// Hot Spots
			$(n.hotspots).each(function (i2, hotspot) {

				var hotspotMarker = $("<div data-id='" + i2 + "' class='hotspot'></div>");
				hotspotMarker.css({
					left:  (hotspot.position.x * 100) + "%",
					top:  (hotspot.position.y * 100) + "%",
				});

				if(hotspot.position.reversed) {
					hotspotMarker.addClass("reversed");
				}

				li.find(".image").append(hotspotMarker)
			});

			// Append to DOM
			$("#maps").append(li)
		});

		// Create timeline items
		$(this.data.maps).each(function (i, n) {
			var li = $("<li></li>");
			li.attr("id", "timeline-item-" + n.name);
			li.html("<div class='timeline-item-dot'></div>");
			li.css("left", parseFloat(n.timeline_position) * $("#timeline-items").width())
			$("#timeline-items").append(li)
		});

		// Create draggable beahavior
		this.draggable = new Draggable.Draggable($("#timeline").get(), {
			// draggable: 'draggable',
			delay: 0,
		});

		// Variable to hold initial position
		var initialPosition;

		// On drag start
		this.draggable.on('drag:start', function (evt) {

			// Define initial position values
			initialPosition = getPosition(evt.data.source);
			initialPosition.offsetX = evt.sensorEvent.clientX - (initialPosition.combinedX);
			initialPosition.offsetY = evt.sensorEvent.clientY - (initialPosition.y);

			// Clear copied transtition of mirror (if any)
			evt.data.mirror.style.transition = '';
		});

		// On drag
		this.draggable.on('drag:move', $.proxy(function (evt) {

			// Stop default beahviour
			evt.cancel();

			var coords = {
				left: constrain(evt.sensorEvent.data.clientX - initialPosition.offsetX, 300, 1700),
				top: initialPosition.y,
			}

			evt.data.mirror.style.transform = "translate3d(" + (coords.left - initialPosition.translateX) + "px, " + coords.top + "px, 0)";
			evt.data.originalSource.style.left = coords.left - this.draggable.containers[0].offsetLeft + 45 + "px";

		}, this));

		// On drag stop
		this.draggable.on('drag:stop', $.proxy(function (evt) {

			// Define nearest point position
			var percentage = (parseInt(evt.data.originalSource.style.left)) / $("#timeline-cursor-track").width();
			var nearestPoint = this.findNearestPoint(percentage);
			var destinationX = this.findPointPosition(this.data.maps[nearestPoint])

			// Snap to nearest
			requestAnimationFrame(function () {
				evt.data.originalSource.style.transition = "left 0.35s ease-in";
				requestAnimationFrame(function () {
					evt.data.originalSource.style.left = destinationX + "px";
				});
			});

			// Display related map
			this.displayMapItem(nearestPoint)

		}, this));


		// On hot spot click
		$("#maps").on("click", ".hotspot", $.proxy(function (e) {
			var hotSpotId = $(e.currentTarget).data("id");
			this.showHotspotViewer(hotSpotId);
		}, this));
	}

	Chronocarte.prototype.displayMapItem = function (mapItem) {

		if (this.currentMapItem == mapItem) {
			return;
		}

		// Save current item ID
		this.currentMapItem = mapItem;

		// Get current item data
		var mapItemData = this.data.maps[mapItem];

		// Build DOM
		$("#maps li").hide();
		$("#maps").find("#" + mapItemData.name).show();

		// Position hotpsot CTA
		if ($("#maps").find("#" + mapItemData.name).find(".image .hotspot").length > 0 && this.viewerHasBeenOpened == false) {
			var hotspotPosition = $("#maps").find("#" + mapItemData.name).find(".image .hotspot").first().offset()
			$("#hotspot-cta").show().css({
				left: hotspotPosition.left + "px",
				top: hotspotPosition.top + "px",
			});
		} else {
			$("#hotspot-cta").hide()
		}

		// Play sound effect
		this.audio.play("audiojungle-21484075-paper-turn.wav");
	}


	Chronocarte.prototype.showHotspotViewer = function (hotspotItem) {
		// console.log(hotspotItem, this.currentMapItem);
		// $("#maps li").hide();
		// $("#maps").find("#" + mapItem.name).show();

		// Define hotpsot data
		var hotspotData = this.data.maps[this.currentMapItem].hotspots[hotspotItem];

		// Remove curent slick slider
		if ($("#hotspot-viewer #hotspot-images-slider").hasClass("slick-slider")) {
			$("#hotspot-viewer #hotspot-images-slider").slick("unslick");
		}

		// Build DOM
		$("#hotspot-viewer #hotspot-images-slider").html("");
		$(hotspotData.images).each(function (i, image) {
			var newItem = $('<li class="hotspot-image"><div class="center-wrapper"><div class="infos-box"></div></div></li>');
			if (image.date_fr) {
				newItem.find(".infos-box").append('<div class="date i18n fading-i18n"><div class="fr">' + image.date_fr + '</div><div class="en">' + image.date_en + '</div></div>');
			}
			if (image.title_fr) {
				newItem.find(".infos-box").append('<div class="title i18n fading-i18n"><div class="fr">' + image.title_fr + '</div><div class="en">' + image.title_en + '</div></div>');
			}
			if (image.content_fr) {
				newItem.find(".infos-box").append('<div class="content i18n fading-i18n"><div class="fr">' + image.content_fr + '</div><div class="en">' + image.content_en + '</div></div>');
			}
			if (image.credits_fr) {
				newItem.find(".infos-box").append('<div class="image-credits i18n fading-i18n"><div class="fr">' + image.credits_fr + '</div><div class="en">' + image.credits_en + '</div></div>');
			}
			newItem.find(".center-wrapper").append('<img src="' + image.src + '"/>');
			$("#hotspot-viewer #hotspot-images-slider").append(newItem);
		});

		$("#hotspot-viewer #hotspot-images-slider").slick({
			variableWidth: false,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: (hotspotData.images.length > 1),
		}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			$("#hotspot-viewer-slider-cta").fadeOut();
		});
		;

		// Toogle dots CTA
		$("#hotspot-viewer-slider-cta").toggle(hotspotData.images.length > 1);

		// Save that this has been opend to avoid showing hotspot CTA again
		this.viewerHasBeenOpened = true;
		$("#hotspot-cta").fadeOut();

		// Show viewer
		requestAnimationFrame(function () {
			$("#hotspot-viewer").addClass("shown");
		});

		// Play sound effect
		this.audio.play("audiojungle-21091270-camera-photo.wav");
	}


	Chronocarte.prototype.closeHotspotViewer = function (hotspotItem) {
		// console.log(hotspotItem);
		// $("#maps li").hide();
		// $("#maps").find("#" + mapItem.name).show();
		$("#hotspot-viewer").removeClass("shown");
	}

	Chronocarte.prototype.findPointPosition = function (point) {
		return parseFloat(point.timeline_position) * $("#timeline-cursor-track").width();
	}

	Chronocarte.prototype.findNearestPoint = function (percentage) {

		var nearestPoint = false;
		var nearestDistance = 200000;

		$(this.data.maps).each($.proxy(function (i, n) {
			var dist = Math.abs(n.timeline_position - percentage);
			if (dist < nearestDistance) {
				nearestPoint = i;
				nearestDistance = dist;
			}
		}, this));

		return nearestPoint
	}

	Chronocarte.prototype.goToHome = function () {
		this.reset();
		this.goToScreen(2);
	}

	Chronocarte.prototype.goToScrenSaver = function () {

		// Super constructor
		var shouldReset = BaseGame.prototype.shouldReset.call(this);

		if (shouldReset) {
			this.reset();
			this.goToScreen(1);
		}
	}

	Chronocarte.prototype.reset = function () {
		this.closeHotspotViewer();
		this.viewerHasBeenOpened = false;
		this.currentMapItem = -1;
	}

	// Expose Chronocarte
	window.Chronocarte = Chronocarte;

})(jQuery, Promise);